import { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import EventoService from '../../services/eventoService';
import NotificacionService from '../../services/notificacionService';
import CrearEventoModal from '../../components/CrearEventoModal';
import ChecklistTramite from '../../components/Tramite/ChecklistTramite';
import BotonCancelarReactivarTramite from '../../components/Tramite/BotonCancelarReactivarTramite';
import TarjetaCobroTramite from '../../components/Cobranzas/TarjetaCobroTramite';
import SeccionCobranzaTramite from '../../components/Cobranzas/SeccionCobranzaTramite';
import HistorialTramite from '../../components/HistorialTramite';
import PanelAccionesAvanzadasTramite from '../../components/Administracion/PanelAccionesAvanzadasTramite';
import BannerEstadoFinal from '../../components/BannerEstadoFinal';
import WhatsAppHeaderButton from '../../components/WhatsAppHeaderButton';
import PanelUbicacionTramite from '../../components/PanelUbicacionTramite';
import FeedbackButton from '../../components/FeedbackButton';
import NotaComentario from '../../components/NotaComentario';
import TarjetaTurnoAnses from '../../components/TarjetaTurnoAnses';
import ExpedientesAnsesTramite, { enSeguimientoDeExpediente } from '../../components/ExpedientesAnsesTramite';
import useCustomModal from '../../hooks/useCustomModal';
import useVolverAtras from '../../hooks/useVolverAtras';
import CustomModal from '../../components/CustomModal';
import { useAuth } from '../../auth/AuthContext';
import { ModalCrearTurno } from '../Recepcion/TurneroPage';
import turneroStyles from '../../style/pages/Turnero.module.css';
import { getTramiteJubilacionById, actualizarChecklistItem, actualizarDocumentoEmpleador, actualizarTramiteJubilacion, actualizarComentariosJubilacion } from '../../services/jubilacionService';
import { getTramitesPlanPago } from '../../services/planPagoService';
import { subirArchivo, descargarArchivo, obtenerArchivosPorTramite, eliminarArchivo } from '../../services/archivoService';
import { actualizarActaHijo } from '../../services/actaHijoService';
import CardReconocimientosServicios from '../../components/Reconocimiento/CardReconocimientosServicios';
import PanelTramitesRelacionados from '../../components/Tramite/PanelTramitesRelacionados';
import BotonGenerarCaratula from '../../components/Caratula/BotonGenerarCaratula';
import { apellidoNombre } from '../../utils/nombrePersona';
import EtiquetaTramite from '../../components/EtiquetaTramite';
import ChipAmparoIniciado from '../../components/Amparo/ChipAmparoIniciado';
import useRegimenesJubilacion from '../../components/Jubilacion/useRegimenesJubilacion';
import ModalNuevoRegimenJubilacion from '../../components/Jubilacion/ModalNuevoRegimenJubilacion';

// Deriva la edad a partir de la fecha de nacimiento (YYYY-MM-DD); sin fecha, sin edad.
const calcularEdad = (fechaNacimiento) => {
    if (!fechaNacimiento) return '';
    const hoy = new Date();
    const nac = new Date(fechaNacimiento);
    let edad = hoy.getFullYear() - nac.getFullYear();
    const m = hoy.getMonth() - nac.getMonth();
    if (m < 0 || (m === 0 && hoy.getDate() < nac.getDate())) edad--;
    return edad >= 0 ? edad : '';
};

// Clase del badge contador (X/Y): verde cuando está completo, gris en caso contrario.
const claseBadgeContador = (completados, total) => (total > 0 && completados === total ? 'bg-success' : 'bg-secondary');

const LABEL_SUBTIPO = {
    ORDINARIA: 'Ordinaria',
    REGIMEN_DIFERENCIAL: 'Régimen Diferencial',
    CASAS_PARTICULARES: 'Casas Particulares',
};
// Opción del desplegable de régimen que abre el alta de un régimen nuevo (no es un valor real).
const OPCION_NUEVO_REGIMEN = '__nuevo__';

const formatLocalFecha = (fechaInput) => {
    if (!fechaInput) return '';
    if (typeof fechaInput === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(fechaInput)) return fechaInput;
    const d = new Date(fechaInput);
    if (Number.isNaN(d.getTime())) return '';
    return new Date(d.getTime() - (d.getTimezoneOffset() * 60000)).toISOString().split('T')[0];
};

function VistaDetalladaTramiteJubilacion() {
    const { idTramite } = useParams();
    const navigate = useNavigate();
    const volverAtras = useVolverAtras('/tramites');
    const { user } = useAuth();
    const { modalState, hideModal, showModal } = useCustomModal();

    const [tramite, setTramite] = useState(null);
    const [loading, setLoading] = useState(true);

    // Edición de datos del trámite (no cliente ni subtipo)
    const [editMode, setEditMode] = useState(false);
    const [tramiteEdit, setTramiteEdit] = useState(null);
    const [guardandoDatos, setGuardandoDatos] = useState(false);

    // Régimen diferencial (dato maestro, con alta al vuelo desde el desplegable de edición).
    // Si el régimen actual del trámite fue desactivado, igual se ofrece para no perderlo al guardar.
    const { regimenes, agregarRegimen } = useRegimenesJubilacion();
    const [modalRegimenOpen, setModalRegimenOpen] = useState(false);
    const opcionesRegimen = tramite?.idRegimenDiferencial && !regimenes.some(r => r.id === tramite.idRegimenDiferencial)
        ? [...regimenes, { id: tramite.idRegimenDiferencial, nombre: tramite.nombreRegimenDiferencial }]
        : regimenes;
    const handleRegimenCreado = (regimen) => {
        agregarRegimen(regimen);
        setTramiteEdit(p => ({ ...p, idRegimenDiferencial: String(regimen.id) }));
        setModalRegimenOpen(false);
    };

    // Herramienta: crear turno prellenado con los datos del cliente del trámite
    const [mostrarModalTurno, setMostrarModalTurno] = useState(false);

    const [eventos, setEventos] = useState([]);
    const [cargandoEventos, setCargandoEventos] = useState(true);
    const [mostrarModalEvento, setMostrarModalEvento] = useState(false);
    const [fechaSeleccionadaEvento, setFechaSeleccionadaEvento] = useState(new Date());

    const [modalHistorialAbierto, setModalHistorialAbierto] = useState(false);
    const [subiendoItem, setSubiendoItem] = useState(null);
    const [subiendoActaHijo, setSubiendoActaHijo] = useState(null);
    const [subiendoDocEmpleador, setSubiendoDocEmpleador] = useState(null);

    // Archivos del trámite (fuente única: el checklist enlaza por idArchivo; "otros" son los no vinculados)
    const [archivos, setArchivos] = useState([]);
    const [subiendoGeneral, setSubiendoGeneral] = useState(false);

    // Planes de Pago 27.705 del mismo cliente (detección por CUIL, sin FK entre módulos)
    const [planesPagoRelacionados, setPlanesPagoRelacionados] = useState([]);
    const [cargandoRelacionados, setCargandoRelacionados] = useState(false);

    const recargarTramite = useCallback(async () => {
        try {
            const data = await getTramiteJubilacionById(idTramite);
            setTramite(data);
        } catch (error) {
            console.error('Error al cargar trámite de Jubilación:', error);
        }
    }, [idTramite]);

    const recargarArchivos = useCallback(async () => {
        try {
            const data = await obtenerArchivosPorTramite(idTramite);
            setArchivos(Array.isArray(data) ? data : []);
        } catch (error) {
            console.error('Error al cargar archivos:', error);
        }
    }, [idTramite]);

    const recargarEventos = useCallback(async () => {
        try {
            const response = await EventoService.getEventosPorTramite(idTramite);
            setEventos(response.data || []);
        } catch (error) {
            console.error('Error recargando eventos:', error);
        }
    }, [idTramite]);

    // Cargar o cancelar un turno ANSES mueve el estado del trámite del lado del backend
    // (TurnoAnsesService.moverEstadoTramite), así que no alcanza con recargar los eventos:
    // sin recargar la carpeta, el badge de estado y el banner de cierre quedan viejos hasta un F5.
    const refrescarPorTurnoAnses = useCallback(async () => {
        await Promise.all([recargarTramite(), recargarEventos()]);
    }, [recargarTramite, recargarEventos]);

    useEffect(() => {
        const cargar = async () => {
            setLoading(true);
            setCargandoEventos(true);
            try {
                const [tramiteResult, eventosResult, archivosResult] = await Promise.allSettled([
                    getTramiteJubilacionById(idTramite),
                    EventoService.getEventosPorTramite(idTramite),
                    obtenerArchivosPorTramite(idTramite),
                ]);
                setTramite(tramiteResult.status === 'fulfilled' ? tramiteResult.value : null);
                setEventos(eventosResult.status === 'fulfilled' ? (eventosResult.value.data || []) : []);
                setArchivos(archivosResult.status === 'fulfilled' && Array.isArray(archivosResult.value) ? archivosResult.value : []);
            } finally {
                setLoading(false);
                setCargandoEventos(false);
            }
        };
        cargar();
    }, [idTramite]);

    // Auto-refresco de eventos (paridad con ART/RTI)
    useEffect(() => {
        const handleEventoCreado = () => recargarEventos();
        window.addEventListener('eventoCreadoDesdeChat', handleEventoCreado);
        const interval = setInterval(() => recargarEventos(), 30000);
        return () => {
            window.removeEventListener('eventoCreadoDesdeChat', handleEventoCreado);
            clearInterval(interval);
        };
    }, [recargarEventos]);

    // Trámites relacionados del cliente: Planes de Pago 27.705 con el mismo CUIL.
    // Detección pura (no hay FK), así que solo se dispara cuando ya conocemos el CUIL del cliente.
    const cuilCliente = tramite?.cliente?.cuil;
    useEffect(() => {
        if (!cuilCliente) { setPlanesPagoRelacionados([]); return; }
        let cancelado = false;
        setCargandoRelacionados(true);
        getTramitesPlanPago(cuilCliente)
            .then((data) => { if (!cancelado) setPlanesPagoRelacionados(Array.isArray(data) ? data : []); })
            .catch((error) => {
                console.error('Error al buscar Planes de Pago relacionados:', error);
                if (!cancelado) setPlanesPagoRelacionados([]);
            })
            .finally(() => { if (!cancelado) setCargandoRelacionados(false); });
        return () => { cancelado = true; };
    }, [cuilCliente]);

    const handleGuardarEvento = async (evento) => {
        try {
            const responseEvento = await EventoService.crearEvento({
                ...evento,
                fecha: formatLocalFecha(evento.fecha),
                idTramite: Number(idTramite),
            });
            const idEventoCreado = responseEvento.data.idEvento || responseEvento.data;
            if (evento.tiemposRecordatorio && evento.tiemposRecordatorio.length > 0) {
                await NotificacionService.programarNotificacionesAutomaticas(idEventoCreado, evento.tiemposRecordatorio);
            }
            window.dispatchEvent(new CustomEvent('eventoCreadoDesdeChat', { detail: { timestamp: Date.now(), source: 'tramite-jubilacion' } }));
            await recargarEventos();
            setMostrarModalEvento(false);
            toast.success('Evento creado correctamente');
        } catch (error) {
            console.error('Error al crear evento:', error);
            toast.error('Error al crear el evento');
        }
    };

    const formatearFechaEvento = (fechaString) => {
        if (!fechaString) return '';
        const [y, m, d] = fechaString.split('T')[0].split('-');
        return `${d}/${m}/${y}`;
    };

    // ---- Descarga con nombre real (extensión + tipo correctos) ----
    const descargarPorId = async (idArchivo) => {
        try {
            const meta = archivos.find(a => a.idArchivo === idArchivo);
            const nombre = meta?.nombre || `archivo_${idArchivo}`;
            const resp = await descargarArchivo(idArchivo);
            const blob = meta?.tipo ? new Blob([resp.data], { type: meta.tipo }) : new Blob([resp.data]);
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = nombre;
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
        } catch (err) {
            console.error('Error al descargar archivo:', err);
            toast.error('No se pudo descargar el archivo');
        }
    };

    // ---- Checklist ----
    const togglePresentado = async (item) => {
        if (item.idArchivo) return; // con archivo adjunto, el ítem queda marcado y bloqueado
        try {
            await actualizarChecklistItem(item.id, { presentado: !item.presentado, idArchivo: null });
            recargarTramite();
        } catch (err) {
            console.error('Error al actualizar checklist:', err);
        }
    };
    const adjuntarArchivo = async (item, file) => {
        if (!file) return;
        setSubiendoItem(item.id);
        try {
            const resp = await subirArchivo(idTramite, file);
            const idArchivo = resp?.idArchivo ?? null;
            await actualizarChecklistItem(item.id, { presentado: true, idArchivo });
            await Promise.all([recargarTramite(), recargarArchivos()]);
        } catch (err) {
            console.error('Error al adjuntar archivo:', err);
            toast.error('No se pudo adjuntar el archivo');
        } finally {
            setSubiendoItem(null);
        }
    };
    const quitarAdjunto = (item) => {
        showModal({
            title: 'Eliminar documento',
            type: 'warning',
            showCancel: true,
            confirmText: 'Sí, eliminar',
            cancelText: 'Cancelar',
            confirmVariant: 'warning',
            message: `¿Seguro que querés eliminar el archivo adjunto de "${item.nombre}"?`,
            onConfirm: async () => {
                try {
                    await eliminarArchivo(item.idArchivo);
                    await actualizarChecklistItem(item.id, { presentado: false, idArchivo: null });
                    await Promise.all([recargarTramite(), recargarArchivos()]);
                    toast.info('Documento eliminado');
                } catch (err) {
                    console.error('Error al eliminar documento:', err);
                    toast.error('No se pudo eliminar el documento');
                }
            },
        });
    };

    // ---- Acta de nacimiento por hijo (mecanismo compartido con Plan de Pago) ----
    const togglePresentadaActa = async (hijo) => {
        if (hijo.idArchivoActa) return; // con archivo adjunto, queda marcado y bloqueado
        try {
            await actualizarActaHijo(idTramite, hijo.idHijo, { presentado: !hijo.actaPresentada, idArchivo: null });
            recargarTramite();
        } catch (err) {
            console.error('Error al actualizar acta de nacimiento:', err);
        }
    };
    const adjuntarActa = async (hijo, file) => {
        if (!file) return;
        setSubiendoActaHijo(hijo.idHijo);
        try {
            const resp = await subirArchivo(idTramite, file);
            const idArchivo = resp?.idArchivo ?? null;
            await actualizarActaHijo(idTramite, hijo.idHijo, { presentado: true, idArchivo });
            await Promise.all([recargarTramite(), recargarArchivos()]);
        } catch (err) {
            console.error('Error al adjuntar acta de nacimiento:', err);
            toast.error('No se pudo adjuntar el acta de nacimiento');
        } finally {
            setSubiendoActaHijo(null);
        }
    };
    const quitarActaAdjunta = (hijo) => {
        showModal({
            title: 'Eliminar acta de nacimiento',
            type: 'warning',
            showCancel: true,
            confirmText: 'Sí, eliminar',
            cancelText: 'Cancelar',
            confirmVariant: 'warning',
            message: `¿Seguro que querés eliminar el acta de nacimiento adjuntada de "${hijo.nombre || 'este hijo'}"?`,
            onConfirm: async () => {
                try {
                    await eliminarArchivo(hijo.idArchivoActa);
                    await actualizarActaHijo(idTramite, hijo.idHijo, { presentado: false, idArchivo: null });
                    await Promise.all([recargarTramite(), recargarArchivos()]);
                    toast.info('Acta de nacimiento eliminada');
                } catch (err) {
                    console.error('Error al eliminar acta de nacimiento:', err);
                    toast.error('No se pudo eliminar el acta de nacimiento');
                }
            },
        });
    };

    // ---- Documentos por empleador doméstico (PS 2.93 / 2.94 / Recibos, cada uno por separado) ----
    const togglePresentadoDocEmpleador = async (idEmpleador, doc) => {
        if (doc.idArchivo) return; // con archivo adjunto, queda marcado y bloqueado
        try {
            await actualizarDocumentoEmpleador(idEmpleador, doc.id, { presentado: !doc.presentado, idArchivo: null });
            recargarTramite();
        } catch (err) {
            console.error('Error al actualizar documento del empleador:', err);
        }
    };
    const adjuntarDocEmpleador = async (idEmpleador, doc, file) => {
        if (!file) return;
        const clave = `${idEmpleador}-${doc.id}`;
        setSubiendoDocEmpleador(clave);
        try {
            const resp = await subirArchivo(idTramite, file);
            const idArchivo = resp?.idArchivo ?? null;
            await actualizarDocumentoEmpleador(idEmpleador, doc.id, { presentado: true, idArchivo });
            await Promise.all([recargarTramite(), recargarArchivos()]);
        } catch (err) {
            console.error('Error al adjuntar documento del empleador:', err);
            toast.error('No se pudo adjuntar el documento');
        } finally {
            setSubiendoDocEmpleador(null);
        }
    };
    const quitarDocEmpleadorAdjunto = (idEmpleador, doc) => {
        showModal({
            title: 'Eliminar documento',
            type: 'warning',
            showCancel: true,
            confirmText: 'Sí, eliminar',
            cancelText: 'Cancelar',
            confirmVariant: 'warning',
            message: `¿Seguro que querés eliminar el archivo adjunto de "${doc.nombre}"?`,
            onConfirm: async () => {
                try {
                    await eliminarArchivo(doc.idArchivo);
                    await actualizarDocumentoEmpleador(idEmpleador, doc.id, { presentado: false, idArchivo: null });
                    await Promise.all([recargarTramite(), recargarArchivos()]);
                    toast.info('Documento eliminado');
                } catch (err) {
                    console.error('Error al eliminar documento adjunto:', err);
                    toast.error('No se pudo eliminar el documento');
                }
            },
        });
    };

    // ---- Otros documentos (no vinculados al checklist) ----
    const subirGeneral = async (file) => {
        if (!file) return;
        setSubiendoGeneral(true);
        try {
            await subirArchivo(idTramite, file);
            await recargarArchivos();
            toast.success('Archivo subido');
        } catch (err) {
            console.error('Error al subir archivo:', err);
            toast.error('No se pudo subir el archivo');
        } finally {
            setSubiendoGeneral(false);
        }
    };
    const eliminarGeneral = (idArchivo) => {
        showModal({
            title: 'Eliminar archivo',
            type: 'warning',
            showCancel: true,
            confirmText: 'Sí, eliminar',
            cancelText: 'Cancelar',
            confirmVariant: 'warning',
            message: '¿Seguro que querés eliminar este archivo? Esta acción no se puede deshacer.',
            onConfirm: async () => {
                try {
                    await eliminarArchivo(idArchivo);
                    await recargarArchivos();
                    toast.info('Archivo eliminado');
                } catch (err) {
                    console.error('Error al eliminar archivo:', err);
                    toast.error('No se pudo eliminar el archivo');
                }
            },
        });
    };

    // ---- Comentarios (nota editable con firma, igual que ART/RTI) ----
    const handleGuardarComentario = async (nuevoComentario) => {
        try {
            await actualizarComentariosJubilacion(idTramite, nuevoComentario);
            await recargarTramite();
            toast.success('Comentario actualizado correctamente');
        } catch (error) {
            console.error('Error al guardar comentario:', error);
            toast.error('No se pudo guardar el comentario');
            throw error;
        }
    };

    // ---- Editar datos del trámite ----
    const handleModificar = () => {
        setTramiteEdit({
            idRegimenDiferencial: tramite.idRegimenDiferencial ? String(tramite.idRegimenDiferencial) : '',
            organismo: tramite.organismo || '',
            aportesProvinciaNoTransferida: !!tramite.aportesProvinciaNoTransferida,
            generaSicam: !!tramite.generaSicam,
            etiqueta: tramite.etiqueta || '',
        });
        setEditMode(true);
    };
    const handleGuardarDatos = async (confirmarRegenerarChecklist = false) => {
        setGuardandoDatos(true);
        try {
            await actualizarTramiteJubilacion(idTramite, {
                ...tramiteEdit,
                organismo: tramiteEdit.organismo || null,
                idRegimenDiferencial: tramiteEdit.idRegimenDiferencial ? Number(tramiteEdit.idRegimenDiferencial) : null,
                confirmarRegenerarChecklist,
            });
            await recargarTramite();
            setEditMode(false);
            toast.success('Datos del trámite actualizados');
        } catch (error) {
            if (error.response?.status === 409 && error.response?.data?.requiereConfirmacion) {
                const items = error.response.data.items || [];
                showModal({
                    title: 'Confirmar cambios en el checklist',
                    type: 'warning',
                    showCancel: true,
                    confirmText: 'Sí, continuar',
                    cancelText: 'Cancelar',
                    confirmVariant: 'warning',
                    message: (
                        <div>
                            <p>Con estos cambios, los siguientes formularios del checklist dejan de requerirse, pero ya tienen un archivo adjunto:</p>
                            <ul className="mb-2">
                                {items.map((it) => (
                                    <li key={it.id}>
                                        <strong>{it.nombre}</strong> — archivo: {it.nombreArchivo || `#${it.idArchivo}`}
                                    </li>
                                ))}
                            </ul>
                            <p className="mb-0">El archivo no se elimina: va a quedar disponible en "Otros documentos". ¿Confirmás continuar?</p>
                        </div>
                    ),
                    onConfirm: () => handleGuardarDatos(true),
                });
            } else {
                console.error('Error al guardar datos:', error);
                toast.error(error.response?.data || 'No se pudieron guardar los datos');
            }
        } finally {
            setGuardandoDatos(false);
        }
    };

    const verDetalleCliente = (cuil) => navigate(`/clientes/vista-detallada/${cuil.toString()}`);

    if (loading) {
        return (
            <div className="text-center my-5">
                <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }}></div>
                <p className="mt-3 fw-semibold" style={{ color: '#6B7280' }}>Cargando trámite...</p>
            </div>
        );
    }
    if (!tramite) {
        return <div className="alert alert-danger mt-4">No se encontró el trámite.</div>;
    }

    const cliente = tramite.cliente || {};
    const formularios = tramite.formularios || [];
    const empleadores = tramite.empleadores || [];
    const hijos = tramite.hijos || [];
    const idsEnChecklist = new Set([
        ...formularios.map(f => f.idArchivo).filter(Boolean),
        ...hijos.map(h => h.idArchivoActa).filter(Boolean),
        ...empleadores.flatMap(e => (e.documentos || []).map(d => d.idArchivo)).filter(Boolean),
    ]);
    const archivosOtros = archivos.filter(a => !idsEnChecklist.has(a.idArchivo));
    const nombrePorId = archivos.reduce((acc, a) => { acc[a.idArchivo] = a.nombre; return acc; }, {});
    const formatTamano = (bytes) => (bytes == null ? '' : (bytes / (1024 * 1024)).toFixed(2) + ' MB');
    const documentosEmpleadores = empleadores.flatMap(e => e.documentos || []);
    const documentosEmpleadoresPresentados = documentosEmpleadores.filter(d => d.presentado).length;

    return (
        <div className="container mt-4">
            {/* Header */}
            <div className="d-flex justify-content-between align-items-start mb-4">
                <div style={{ flex: '1 1 20rem', minWidth: 0 }}>
                    <div className="d-flex align-items-center flex-wrap gap-3 mb-1">
                        <h2 className="fw-bold text-primary mb-0">Detalles del Trámite de Jubilación</h2>
                        <span className="badge bg-primary bg-opacity-10 text-primary border border-primary-subtle rounded-pill fs-6 px-3">
                            JUBILACIÓN
                        </span>
                        <EtiquetaTramite etiqueta={tramite.etiqueta} />
                        {/* Si sobre este expediente se promovio un amparo por mora ante ANSES, avisa
                            y linkea a su ficha (V239). Es lo que el Excel anota a mano como
                            "AMPARO INICIADO" sobre la fila del tramite. */}
                        <ChipAmparoIniciado idTramite={tramite.idTramite} />
                    </div>
                    {cliente?.apellido && cliente?.nombre && (
                        <div className="d-flex align-items-center gap-2 flex-wrap mt-2">
                            <h5 className="text-secondary fw-semibold mb-0">
                                <PersonSearchIcon fontSize="small" className="me-1 mb-1" />
                                {apellidoNombre(cliente.apellido, cliente.nombre)}
                            </h5>
                            {cliente.telefonoPropio && (
                                <WhatsAppHeaderButton
                                    phone={cliente.telefonoPropio}
                                    clientName={`${cliente.nombre} ${cliente.apellido}`}
                                    onClick={() => window.dispatchEvent(
                                        new CustomEvent('openAdminSidebar', { detail: { tab: 'whatsapp' } })
                                    )}
                                />
                            )}
                        </div>
                    )}
                    <PanelUbicacionTramite tramite={tramite} onUpdated={setTramite} />
                </div>
                <div className="d-flex gap-2 mt-1 align-items-center flex-wrap">
                    <BotonGenerarCaratula
                        tipo="JUBILACION"
                        idTramite={tramite.idTramite}
                        onGenerado={recargarArchivos}
                    />
                    <button
                        className="btn btn-outline-primary d-flex align-items-center gap-2 rounded-pill"
                        onClick={() => setMostrarModalTurno(true)}
                    >
                        <i className="bi bi-calendar-plus"></i> Crear turno
                    </button>
                    <button
                        className="btn btn-outline-secondary d-flex align-items-center gap-2 rounded-pill"
                        onClick={volverAtras}
                    >
                        <ArrowBackIcon fontSize="small" /> Volver
                    </button>
                </div>
            </div>

            <BannerEstadoFinal
                idTramite={tramite.idTramite}
                nombreEstadoActual={tramite.nombreEstadoActual}
            />

            {/* Estado + historial */}
            <div
                className="card shadow-sm border-0 rounded-4 p-4 mb-3"
                style={{ backgroundColor: '#f8f9fa', cursor: 'pointer', transition: 'all 0.2s ease' }}
                onClick={() => setModalHistorialAbierto(true)}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#e9ecef'; }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#f8f9fa'; }}
            >
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex align-items-center gap-3">
                        <h5 className="fw-bold text-secondary mb-0">Estado</h5>
                        <span className="badge bg-success bg-opacity-10 text-success border border-success-subtle rounded-pill fs-6 px-3">
                            {tramite.nombreEstadoActual || 'Ingreso del Trámite'}
                        </span>
                        {tramite.fechaEstadoActual && (
                            <span className="text-muted small">
                                {new Date(tramite.fechaEstadoActual).toLocaleDateString('es-ES')}
                            </span>
                        )}
                    </div>
                    <span className="text-primary">
                        <i className="bi bi-arrow-right-circle me-1"></i>Ver historial
                    </span>
                </div>
            </div>

            {/* Nota editable de comentarios (con firma, igual que ART/RTI) */}
            <NotaComentario
                valor={tramite.comentarios || ''}
                onGuardar={handleGuardarComentario}
                label="Comentarios del Trámite de Jubilación"
                color="blue"
                nombreUsuario={user?.nombre || ''}
            />

            {/* Cobranza del trámite: desplegable, debajo del estado y los comentarios */}
            <SeccionCobranzaTramite tramite={tramite} />

            {/* Turno en ANSES: hito propio del trámite. Al cargarlo se genera la citación al
                estudio en el turnero y el evento de agenda. */}
            <TarjetaTurnoAnses
                idTramite={tramite.idTramite}
                cuilCliente={tramite.idCliente || cliente.cuil}
                nombreArea="este trámite de Jubilación"
                nombreEstadoActual={tramite.nombreEstadoActual}
                onCambio={refrescarPorTurnoAnses}
                onEstadoCambiado={refrescarPorTurnoAnses}
            />
            {enSeguimientoDeExpediente(tramite.nombreEstadoActual) && <ExpedientesAnsesTramite idTramite={tramite.idTramite} />}

            {/* Eventos del Trámite */}
            <div className="row mb-3">
                <div className="col-12">
                    <div className="card shadow-lg border-0 rounded-4 p-4">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h4 className="fw-bold text-primary mb-0">Eventos del Trámite</h4>
                            <button
                                className="btn btn-outline-primary d-flex align-items-center gap-2 rounded-pill fw-semibold"
                                onClick={() => {
                                    const hoy = new Date();
                                    setFechaSeleccionadaEvento(new Date(hoy.getFullYear(), hoy.getMonth(), hoy.getDate()));
                                    setMostrarModalEvento(true);
                                }}
                            >
                                <span style={{ fontSize: '1.2rem' }}>+</span> Crear Evento
                            </button>
                        </div>
                        {cargandoEventos ? (
                            <div className="text-center py-4">
                                <div className="spinner-border text-primary" role="status"></div>
                                <p className="mt-2 text-muted">Cargando eventos...</p>
                            </div>
                        ) : eventos.length === 0 ? (
                            <div className="alert alert-info border-0 rounded-3 text-center">
                                <p className="mb-0">No hay eventos registrados para este trámite</p>
                            </div>
                        ) : (
                            <div className="row g-3">
                                {eventos.map(evento => (
                                    <div key={evento.idEvento} className="col-md-6 col-lg-4">
                                        <div className="card h-100 border rounded-3 p-3 shadow-sm">
                                            <div className="d-flex justify-content-between align-items-start mb-2">
                                                <h6 className="fw-bold text-primary mb-0">{evento.titulo}</h6>
                                                {evento.tipoEvento && <span className="badge bg-primary rounded-pill">{evento.tipoEvento}</span>}
                                            </div>
                                            {evento.descripcion && <p className="text-muted small mb-2">{evento.descripcion}</p>}
                                            <div className="mt-auto">
                                                <div className="d-flex align-items-center gap-2 mb-1">
                                                    <small className="text-muted">📅</small>
                                                    <small className="fw-semibold">{formatearFechaEvento(evento.fecha)}</small>
                                                </div>
                                                {evento.todoElDia ? (
                                                    <div className="d-flex align-items-center gap-2">
                                                        <small className="text-muted">🕐</small>
                                                        <small className="text-success fw-semibold">Todo el día</small>
                                                    </div>
                                                ) : (
                                                    <div className="d-flex align-items-center gap-2">
                                                        <small className="text-muted">🕐</small>
                                                        <small>{evento.horaInicio} - {evento.horaFin}</small>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Info del Trámite + Info del Cliente */}
            <div className="row g-4">
                <div className="col-lg-6">
                    <div className="card shadow-lg border-0 rounded-4 p-4 h-100">
                        <h4 className="fw-bold text-primary mb-3">
                            <i className="bi bi-person-vcard me-2"></i>
                            Información del Trámite
                        </h4>
                        {!editMode ? (
                            <>
                                <p><strong>Subtipo:</strong> {LABEL_SUBTIPO[tramite.subtipo] || tramite.subtipo || 'N/A'}</p>
                                {tramite.nombreRegimenDiferencial && (
                                    <p><strong>Régimen diferencial:</strong> {tramite.nombreRegimenDiferencial}</p>
                                )}
                                <p><strong>Organismo:</strong> {tramite.organismo === 'ANSES' ? 'ANSES' : tramite.organismo === 'PROVINCIA' ? 'Provincia' : 'Sin especificar'}</p>
                                <p><strong>Reconocimiento de servicios:</strong> {tramite.aportesProvinciaNoTransferida ? 'Sí' : 'No'}</p>
                                <p><strong>Genera SICAM:</strong> {tramite.generaSicam ? 'Sí' : 'No'}</p>
                                {tramite.etiqueta && <p><strong>Etiqueta:</strong> {tramite.etiqueta}</p>}
                                <ChecklistTramite tramite={tramite} onActualizado={recargarTramite} />
                                <TarjetaCobroTramite
                                    tramite={tramite}
                                    onPactoGenerado={() => Promise.all([recargarTramite(), recargarArchivos()])}
                                />
                                <div className="mt-3 d-flex gap-2 flex-wrap">
                                    <button className="btn btn-outline-primary rounded-pill px-4 fw-semibold" onClick={handleModificar}>
                                        <i className="bi bi-pencil me-2"></i>Editar datos
                                    </button>
                                    <BotonCancelarReactivarTramite tramite={tramite} onActualizado={recargarTramite} />
                                </div>
                            </>
                        ) : (
                            <>
                                <p className="mb-3"><strong>Subtipo:</strong> {LABEL_SUBTIPO[tramite.subtipo] || tramite.subtipo} <span className="text-muted small">(no editable)</span></p>
                                {tramite.subtipo === 'REGIMEN_DIFERENCIAL' && (
                                    <div className="mb-3">
                                        <label className="form-label fw-semibold">Régimen diferencial</label>
                                        <select className="form-select" value={tramiteEdit.idRegimenDiferencial || ''}
                                            onChange={(e) => {
                                                const { value } = e.target;
                                                if (value === OPCION_NUEVO_REGIMEN) {
                                                    setModalRegimenOpen(true);
                                                    return;
                                                }
                                                setTramiteEdit(p => ({ ...p, idRegimenDiferencial: value }));
                                            }}>
                                            <option value="">Sin especificar</option>
                                            {opcionesRegimen.map(r => <option key={r.id} value={String(r.id)}>{r.nombre}</option>)}
                                            <option value={OPCION_NUEVO_REGIMEN}>+ Crear nuevo régimen…</option>
                                        </select>
                                    </div>
                                )}
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Organismo</label>
                                    <select className="form-select" value={tramiteEdit.organismo || ''}
                                        onChange={(e) => setTramiteEdit(p => ({ ...p, organismo: e.target.value }))}>
                                        <option value="">Sin especificar</option>
                                        <option value="ANSES">ANSES</option>
                                        <option value="PROVINCIA">Provincia</option>
                                    </select>
                                </div>
                                <div className="form-check mb-2">
                                    <input className="form-check-input" type="checkbox" id="edit-aportes"
                                        checked={!!tramiteEdit.aportesProvinciaNoTransferida}
                                        onChange={(e) => setTramiteEdit(p => ({ ...p, aportesProvinciaNoTransferida: e.target.checked }))} />
                                    <label className="form-check-label" htmlFor="edit-aportes">Reconocimiento de servicios (provincia no transferida)</label>
                                </div>
                                <div className="form-check mb-3">
                                    <input className="form-check-input" type="checkbox" id="edit-sicam"
                                        checked={!!tramiteEdit.generaSicam}
                                        onChange={(e) => setTramiteEdit(p => ({ ...p, generaSicam: e.target.checked }))} />
                                    <label className="form-check-label" htmlFor="edit-sicam">Genera SICAM</label>
                                </div>
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Etiqueta</label>
                                    <input type="text" className="form-control" value={tramiteEdit.etiqueta || ''}
                                        onChange={(e) => setTramiteEdit(p => ({ ...p, etiqueta: e.target.value }))} />
                                </div>
                                <div className="d-flex gap-2">
                                    <button className="btn btn-primary rounded-pill px-4 fw-semibold" onClick={() => handleGuardarDatos()} disabled={guardandoDatos}>
                                        {guardandoDatos ? <span className="spinner-border spinner-border-sm" role="status"></span> : <><i className="bi bi-check-circle me-2"></i>Guardar</>}
                                    </button>
                                    <button className="btn btn-outline-secondary rounded-pill px-4" onClick={() => setEditMode(false)}>Cancelar</button>
                                </div>
                            </>
                        )}
                    </div>
                </div>

                <div className="col-lg-6">
                    <div className="card shadow-lg border-0 rounded-4 p-4 h-100">
                        <h4 className="fw-bold mb-3" style={{ color: '#6c757d' }}>Información del Cliente</h4>
                        <p><strong>CUIL:</strong> {cliente.cuil || 'N/A'}</p>
                        <p><strong>Nombre:</strong> {cliente.nombre || 'N/A'}</p>
                        <p><strong>Apellido:</strong> {cliente.apellido || 'N/A'}</p>
                        <p><strong>Oficio / Actividad:</strong> {cliente.oficio || 'N/A'}</p>
                        <p><strong>Teléfono:</strong> {cliente.telefonoPropio || 'N/A'}</p>
                        {cliente.nivelEducativo && (
                            <p><strong>Nivel educativo:</strong> {cliente.nivelEducativo?.nombre || cliente.nivelEducativo}</p>
                        )}
                        {cliente.cuil && (
                            <div className="mt-3 d-flex justify-content-center">
                                <button
                                    className="btn btn-outline-secondary d-flex align-items-center gap-2 rounded-pill px-4 py-2 fw-semibold"
                                    onClick={() => verDetalleCliente(cliente.cuil)}
                                >
                                    <PersonSearchIcon fontSize="medium" /> Ver Detalle del Cliente
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Expedientes de ANSES: acá, debajo de los datos del trámite y del cliente; arriba solo
                mientras el trámite está en "Seguimiento de Expediente". */}
            {!enSeguimientoDeExpediente(tramite.nombreEstadoActual) && <ExpedientesAnsesTramite idTramite={tramite.idTramite} />}

            {/* Empleadores domésticos */}
            {empleadores.length > 0 && (
                <div className="row g-4 mt-1">
                    <div className="col-12">
                        <div className="card shadow-lg border-0 rounded-4 p-4">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h4 className="fw-bold text-primary mb-0"><i className="bi bi-people me-2"></i>Empleadores domésticos</h4>
                                <span className={`badge ${claseBadgeContador(documentosEmpleadoresPresentados, documentosEmpleadores.length)}`}>
                                    {documentosEmpleadoresPresentados}/{documentosEmpleadores.length} documentos
                                </span>
                            </div>
                            <div className="row g-3">
                                {empleadores.map(e => (
                                    <div key={e.id} className="col-md-6">
                                        <div className="border rounded-4 p-3 h-100" style={{ background: '#f8fafc' }}>
                                            <div className="d-flex justify-content-between align-items-start gap-2 mb-2">
                                                <h6 className="fw-bold text-primary mb-0">{e.nombre}</h6>
                                                <div className="d-flex gap-1 flex-wrap justify-content-end">
                                                    {e.tieneContacto && !e.fallecido && <span className="badge rounded-pill" style={{ background: '#dcfce7', color: '#166534' }}>Contacto vigente</span>}
                                                    {e.fallecido && <span className="badge rounded-pill" style={{ background: '#fee2e2', color: '#991b1b' }}>Fallecido</span>}
                                                    {!e.fallecido && !e.tieneContacto && <span className="badge rounded-pill" style={{ background: '#fef3c7', color: '#92400e' }}>Sin contacto</span>}
                                                    {e.tieneRecibos && <span className="badge rounded-pill" style={{ background: '#dbeafe', color: '#1e40af' }}>Con recibos</span>}
                                                </div>
                                            </div>
                                            <hr className="my-2" />
                                            {(e.documentos || []).length === 0 ? (
                                                <p className="text-muted small mb-0">Sin documentos requeridos.</p>
                                            ) : (
                                                <ul className="list-group list-group-flush">
                                                    {e.documentos.map(doc => (
                                                        <li key={doc.id} className="list-group-item d-flex justify-content-between align-items-center flex-wrap gap-2 px-0 bg-transparent">
                                                            <div className="form-check mb-0">
                                                                <input className="form-check-input" type="checkbox" id={`doc-${e.id}-${doc.id}`}
                                                                    checked={!!doc.presentado} disabled={!!doc.idArchivo}
                                                                    onChange={() => togglePresentadoDocEmpleador(e.id, doc)} />
                                                                <label className="form-check-label small" htmlFor={`doc-${e.id}-${doc.id}`}
                                                                    style={{ textDecoration: doc.presentado ? 'line-through' : 'none', color: doc.presentado ? '#6c757d' : 'inherit' }}>
                                                                    {doc.nombre}
                                                                </label>
                                                            </div>
                                                            <div className="d-flex align-items-center gap-2">
                                                                {doc.idArchivo ? (
                                                                    <>
                                                                        <button className="btn btn-sm btn-outline-primary rounded-pill"
                                                                            onClick={() => descargarPorId(doc.idArchivo)}
                                                                            title={nombrePorId[doc.idArchivo] || 'Descargar'}>
                                                                            <i className="bi bi-download me-1"></i>
                                                                            {nombrePorId[doc.idArchivo] || 'Descargar'}
                                                                        </button>
                                                                        <button className="btn btn-sm btn-link text-danger p-0" title="Quitar adjunto"
                                                                            onClick={() => quitarDocEmpleadorAdjunto(e.id, doc)}>
                                                                            <i className="bi bi-x-circle"></i>
                                                                        </button>
                                                                    </>
                                                                ) : (
                                                                    <label className="btn btn-sm btn-outline-secondary rounded-pill mb-0">
                                                                        {subiendoDocEmpleador === `${e.id}-${doc.id}`
                                                                            ? <span className="spinner-border spinner-border-sm" role="status"></span>
                                                                            : <><i className="bi bi-paperclip me-1"></i>Adjuntar</>}
                                                                        <input type="file" accept="application/pdf" hidden
                                                                            onChange={(ev) => adjuntarDocEmpleador(e.id, doc, ev.target.files[0])} />
                                                                    </label>
                                                                )}
                                                            </div>
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Hijos (autocompletados desde el Cliente) */}
            {hijos.length > 0 && (
                <div className="row g-4 mt-1">
                    <div className="col-12">
                        <div className="card shadow-lg border-0 rounded-4 p-4">
                            <div className="d-flex justify-content-between align-items-center mb-3">
                                <h4 className="fw-bold text-primary mb-0"><i className="bi bi-people me-2"></i>Hijos</h4>
                                <span className={`badge ${claseBadgeContador(hijos.filter(h => h.actaPresentada).length, hijos.length)}`}>
                                    {hijos.filter(h => h.actaPresentada).length}/{hijos.length} actas
                                </span>
                            </div>
                            <div className="row g-3">
                                {hijos.map(h => (
                                    <div key={h.idHijo} className="col-md-6">
                                        <div className="border rounded-4 p-3 h-100" style={{ background: '#f8fafc' }}>
                                            <div className="d-flex justify-content-between align-items-start gap-2 mb-2">
                                                <div>
                                                    <h6 className="fw-bold text-primary mb-0">{h.nombre || 'Sin nombre'}</h6>
                                                    <small className="text-muted">Edad: {calcularEdad(h.fechaNacimiento) || '—'}</small>
                                                </div>
                                                <div className="d-flex gap-1 flex-wrap justify-content-end">
                                                    {h.tieneAuh && <span className="badge rounded-pill" style={{ background: '#dbeafe', color: '#1e40af' }}>AUH</span>}
                                                    {h.tieneCud && <span className="badge rounded-pill" style={{ background: '#ede9fe', color: '#5b21b6' }}>CUD</span>}
                                                    {h.esAdoptado && <span className="badge rounded-pill" style={{ background: '#fef3c7', color: '#92400e' }}>Adoptado/a</span>}
                                                </div>
                                            </div>
                                            <hr className="my-2" />
                                            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                                                <div className="form-check mb-0">
                                                    <input className="form-check-input" type="checkbox" id={`acta-${h.idHijo}`}
                                                        checked={!!h.actaPresentada} disabled={!!h.idArchivoActa}
                                                        onChange={() => togglePresentadaActa(h)} />
                                                    <label className="form-check-label small" htmlFor={`acta-${h.idHijo}`}
                                                        style={{ textDecoration: h.actaPresentada ? 'line-through' : 'none', color: h.actaPresentada ? '#6c757d' : 'inherit' }}>
                                                        Acta de nacimiento
                                                    </label>
                                                </div>
                                                <div className="d-flex align-items-center gap-2">
                                                    {h.idArchivoActa ? (
                                                        <>
                                                            <button className="btn btn-sm btn-outline-primary rounded-pill"
                                                                onClick={() => descargarPorId(h.idArchivoActa)}
                                                                title={nombrePorId[h.idArchivoActa] || 'Descargar'}>
                                                                <i className="bi bi-download me-1"></i>
                                                                {nombrePorId[h.idArchivoActa] || 'Descargar'}
                                                            </button>
                                                            <button className="btn btn-sm btn-link text-danger p-0" title="Quitar adjunto"
                                                                onClick={() => quitarActaAdjunta(h)}>
                                                                <i className="bi bi-x-circle"></i>
                                                            </button>
                                                        </>
                                                    ) : (
                                                        <label className="btn btn-sm btn-outline-secondary rounded-pill mb-0">
                                                            {subiendoActaHijo === h.idHijo
                                                                ? <span className="spinner-border spinner-border-sm" role="status"></span>
                                                                : <><i className="bi bi-paperclip me-1"></i>Adjuntar</>}
                                                            <input type="file" accept="application/pdf" hidden
                                                                onChange={(e) => adjuntarActa(h, e.target.files[0])} />
                                                        </label>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Reconocimientos de Servicios vinculados a esta Jubilación */}
            <CardReconocimientosServicios idTramitePadre={tramite.idTramite} cliente={cliente} />

            {/* Trámites relacionados del cliente: Planes de Pago 27.705 detectados por CUIL (sin FK) */}
            <PanelTramitesRelacionados
                titulo="Trámites relacionados del cliente"
                icono="bi-diagram-3"
                tramites={planesPagoRelacionados}
                cargando={cargandoRelacionados}
                textoVacio="Este cliente no tiene Planes de Pago 27.705 cargados."
            />

            {/* Documentación del Trámite: checklist de formularios + otros documentos (un solo lugar) */}
            <div className="row g-4 mt-1">
                <div className="col-12">
                    <div className="card shadow-lg border-0 rounded-4 p-4">
                        <h4 className="fw-bold text-primary mb-3"><i className="bi bi-folder2-open me-2"></i>Documentación del Trámite</h4>

                        {/* Formularios requeridos */}
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h6 className="fw-bold text-secondary mb-0"><i className="bi bi-check2-square me-2"></i>Formularios requeridos</h6>
                            <span className={`badge ${claseBadgeContador(formularios.filter(f => f.presentado).length, formularios.length)}`}>{formularios.filter(f => f.presentado).length}/{formularios.length}</span>
                        </div>
                        {formularios.length === 0 ? (
                            <div className="alert alert-info border-0 rounded-3 text-center mb-0">
                                <p className="mb-0">No hay formularios en el checklist.</p>
                            </div>
                        ) : (
                            <ul className="list-group list-group-flush">
                                {formularios.map(f => (
                                    <li key={f.id} className="list-group-item d-flex justify-content-between align-items-center flex-wrap gap-2 px-0">
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" id={`chk-${f.id}`}
                                                checked={!!f.presentado} disabled={!!f.idArchivo}
                                                onChange={() => togglePresentado(f)} />
                                            <label className="form-check-label" htmlFor={`chk-${f.id}`}
                                                style={{ textDecoration: f.presentado ? 'line-through' : 'none', color: f.presentado ? '#6c757d' : 'inherit' }}>
                                                {f.nombre}
                                            </label>
                                        </div>
                                        <div className="d-flex align-items-center gap-2">
                                            {f.idArchivo ? (
                                                <>
                                                    <button className="btn btn-sm btn-outline-primary rounded-pill"
                                                        onClick={() => descargarPorId(f.idArchivo)}
                                                        title={nombrePorId[f.idArchivo] || 'Descargar'}>
                                                        <i className="bi bi-download me-1"></i>
                                                        {nombrePorId[f.idArchivo] || 'Descargar'}
                                                    </button>
                                                    <button className="btn btn-sm btn-link text-danger p-0" title="Quitar adjunto"
                                                        onClick={() => quitarAdjunto(f)}>
                                                        <i className="bi bi-x-circle"></i>
                                                    </button>
                                                </>
                                            ) : (
                                                <label className="btn btn-sm btn-outline-secondary rounded-pill mb-0">
                                                    {subiendoItem === f.id
                                                        ? <span className="spinner-border spinner-border-sm" role="status"></span>
                                                        : <><i className="bi bi-paperclip me-1"></i>Adjuntar</>}
                                                    <input type="file" accept="application/pdf" hidden
                                                        onChange={(e) => adjuntarArchivo(f, e.target.files[0])} />
                                                </label>
                                            )}
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        )}

                        <hr className="my-4" />

                        {/* Otros documentos (no vinculados a un formulario) */}
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h6 className="fw-bold text-secondary mb-0"><i className="bi bi-paperclip me-2"></i>Otros documentos</h6>
                            <label className="btn btn-sm btn-outline-primary rounded-pill mb-0">
                                {subiendoGeneral
                                    ? <span className="spinner-border spinner-border-sm" role="status"></span>
                                    : <><i className="bi bi-cloud-upload me-1"></i>Subir archivo</>}
                                <input type="file" hidden onChange={(e) => { subirGeneral(e.target.files[0]); e.target.value = ''; }} />
                            </label>
                        </div>
                        {archivosOtros.length === 0 ? (
                            <p className="text-muted fst-italic mb-0">No hay otros documentos cargados.</p>
                        ) : (
                            <div className="d-flex flex-column gap-2">
                                {archivosOtros.map(a => (
                                    <div key={a.idArchivo} className="d-flex align-items-center justify-content-between border rounded-3 px-3 py-2">
                                        <div className="d-flex align-items-center gap-2" style={{ minWidth: 0 }}>
                                            <i className="bi bi-file-earmark-text text-primary" style={{ fontSize: '1.25rem' }}></i>
                                            <div style={{ minWidth: 0 }}>
                                                <div className="fw-semibold text-truncate" style={{ cursor: 'pointer', textDecoration: 'underline' }}
                                                    onClick={() => descargarPorId(a.idArchivo)} title={a.nombre}>
                                                    {a.nombre}
                                                </div>
                                                <small className="text-muted">{formatTamano(a.tamaño)}</small>
                                            </div>
                                        </div>
                                        <div className="d-flex align-items-center gap-1 flex-shrink-0">
                                            <button className="btn btn-sm" style={{ color: '#0056b3', border: 'none' }} title="Descargar"
                                                onClick={() => descargarPorId(a.idArchivo)}>
                                                <i className="bi bi-download"></i>
                                            </button>
                                            <button className="btn btn-sm" style={{ color: '#dc3545', border: 'none' }} title="Eliminar"
                                                onClick={() => eliminarGeneral(a.idArchivo)}>
                                                <i className="bi bi-trash"></i>
                                            </button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Modal crear evento */}
            <CrearEventoModal
                isOpen={mostrarModalEvento}
                onClose={() => setMostrarModalEvento(false)}
                onSave={handleGuardarEvento}
                selectedDate={fechaSeleccionadaEvento}
                idTramite={idTramite}
            />

            {/* Acciones irreversibles (cambiar tipo / eliminar definitivamente).
                El propio panel decide si mostrarse segun el rol. */}
            <PanelAccionesAvanzadasTramite
                idTramite={tramite?.idTramite}
                tipoTramite="JUBILACION"
            />

            {/* Modal historial de estados (ámbito JUBILACION) */}
            <HistorialTramite
                isOpen={modalHistorialAbierto}
                onClose={() => setModalHistorialAbierto(false)}
                idTramite={idTramite}
                onEstadoCambiado={recargarTramite}
                ambitoFiltro="JUBILACION"
            />

            {/* Modal crear turno (reutiliza el turnero de Recepción, prellenado con el cliente) */}
            {mostrarModalTurno && (
                <div className={turneroStyles.overlay} onClick={() => setMostrarModalTurno(false)}>
                    <div className={turneroStyles.contenidoModal} onClick={(e) => e.stopPropagation()}>
                        <ModalCrearTurno
                            celdaSel={null}
                            valoresIniciales={{
                                nombre: cliente.nombre || '',
                                apellido: cliente.apellido || '',
                                cuil: cliente.cuil || '',
                                telefono: cliente.telefonoPropio || '',
                                tipoTramite: 'JUBILACION',
                            }}
                            onCerrar={() => setMostrarModalTurno(false)}
                            onCreado={() => { setMostrarModalTurno(false); toast.success('Turno creado correctamente'); }}
                        />
                    </div>
                </div>
            )}

            <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop closeOnClick pauseOnHover />
            <CustomModal {...modalState} onHide={hideModal} />
            <ModalNuevoRegimenJubilacion show={modalRegimenOpen} onHide={() => setModalRegimenOpen(false)} onCreado={handleRegimenCreado} />
            <FeedbackButton tramite={tramite} />
        </div>
    );
}

export default VistaDetalladaTramiteJubilacion;
